export default __webpack_public_path__ + "static/media/TransactionSuccessful.caa31cc3.svg";